import { getStage } from '@/src/homepage/api/utils';
import { Stage } from '@eventbrite/webapp-constants';

/**
 * Determines the mobile BFF API gateway URL based on the stage
 * @returns The appropriate API gateway URL
 */
export function getMobileBffApiGateway(): string {
    const MOBILE_BFF_APIGW_TEST = 'apigw-guides-mobile-bff.auolhivc.ext.evbqa.com';
    const MOBILE_BFF_APIGW_PROD = 'apigw-guides-mobile-bff.x46tnyof.ext.eventbrite.com';

    const currentStage = getStage();

    if (currentStage === Stage.PROD) {
        return MOBILE_BFF_APIGW_PROD;
    } else {
        return MOBILE_BFF_APIGW_TEST;
    }
}
